export default {
  minLength: 'حداقل تعداد کاراکتر',
  maxLength: 'حداکثر تعداد کاراکتر',
  addAttribute: 'افزودن ویژگی',
  customAttribute: 'ویژگی دلخواه',
  showQuestionNumber: 'نمایش شماره سوال',
  textareaRowCount: 'تعداد خطوط',
  minValue: 'حداقل مقدار',
  maxValue: 'حداکثر مقدار',
  decimalNumber: 'عدد اعشاری',
  areYouSureYouWantToDeleteThisAttribute: 'از حذف این ویژگی اطمینان دارید؟',
  addCustomAttribute: 'افزودن ویژگی دلخواه',
  attrTypes: {
    string: 'متنی',
    number: 'عدد',
    boolean: 'بله/خیر',
    object: 'کلید:مقدار'
  },
  duplicatedItem: 'آیتم تکراری است',
  thumbAttrs: 'تصویر',
  id: 'id',
  class: 'کلاس',
  style: 'استایل',
  width: 'عرض',
  height: 'طول',
  accept: 'پسوند های مجاز',
  optionAttrs: 'گزینه',
  colAttrs: 'ستون',
  textAttrs: 'متن',
  show: 'نمایش',
  descriptionAttrs: 'توضیحات',
  optionNumberAttrs: 'شماره گزینه',
  numberingType: 'روش شماره گذاری',
  numberingTypeOptions: {
    number: 'عدد (1, 2, 3, ...)',
    persianAlphabet: 'الفبای فارسی (الف، ب، پ، ...)',
    englishAlphabet: 'الفبای انگلیسی (A, B, C, ...)'
  },
  inputName: 'عنوان ورودی',
  imageOptionAttrs: 'گزینه',
  src: 'آدرس تصویر',
  format: 'فرمت',
  noImageUrl: 'آدرس تصویر پیشفرض',
  gif: 'گیف',
  showNoImage: 'تصویر پیشفرض',
  fitIn: 'اصلاح مقیاس تصویر',
  fluidGrow: 'ریسپانسیو و رشدپذیر',
  fluid: 'ریسپانسیو',
  thumbor: 'بهینه سازی حجم',
  effects: 'جلوه‌های تصویر',
  brightness: 'روشنایی',
  blur: 'میزان تار بودن',
  contrast: 'کنتراست',
  quality: 'کیفیت',
  dropdownAttrs: 'لیست کشویی',
  uploaderAttrs: 'آپلودر',
  multiple: 'چندتایی',
  squareImage: 'فقط تصویر مربع',
  uploadMaxSize: 'حداکثر حجم فایل (بایت)',
  autoScale: 'مقیاس خودکار (پیکسل)',
  rangeAttrs: 'طیف',
  min: 'حداقل',
  max: 'حداکثر',
  interval: 'فواصل',
  duration: 'مدت زمان انیمیشن',
  marks: 'نمایش مقادیر',
  scoreAttrs: 'امتیازدهی',
  inactiveColor: 'رنگ غیرفعال',
  activeColor: 'رنگ فعال',
  borderColor: 'رنگ حاشیه',
  activeBorderColor: 'رنگ حاشیه فعال',
  glowColor: 'رنگ درخشش',
  textClass: 'کلاس متن',
  increment: 'میزان افزایش',
  rating: 'امتیاز',
  maxRating: 'حداکثر امتیاز',
  fixedPoints: 'ممیز ثابت',
  starSize: 'اندازه ستاره',
  borderWidth: 'عرض حاشیه',
  glow: 'درخشش',
  readOnly: 'فقط خواندنی',
  showRating: 'نمایش امتیاز',
  rtl: 'راست چین',
  roundStartRating: 'روند کردن امتیاز',
  clearable: 'قابل پاک شدن',
  roundedCorners: 'گوشه های گرد ',
  template: 'قالب',
  self: 'همان صفحه',
  blank: 'صفحه جدید',
  wrapperAttrs: 'تگ ویجت',
  widgetAttrs: 'ویجت',
  headerAttrs: 'هدر ویجت',
  rowAttrs: 'تگ row',
  swiperAttrs: 'اسلایدر',
  linkAttrs: 'لینک',
  iconAttrs: 'آیکن',
  contentAttrs: 'تگ محتوا',
  ulAttrs: 'لیست',
  liAttrs: 'آیتم لیست',
  titleAttrs: 'عنوان',
  subTitleAttrs: 'زیرعنوان',
  dividerAttrs: 'خط جداساز',
  titleDividerAttrs: 'خط جداساز عنوان',
  moreLinkAttrs: 'لینک موارد بیشتر',
  showHeader: 'نمایش هدر',
  showDivider: 'نمایش خط جداساز',
  showTitleDivider: 'نمایش خط جداساز عنوان',
  showMoreLink: 'نمایش لینک موارد بیشتر',
  to: 'لینک',
  target: 'نحوه باز شدن',
  text: 'متن',
  icon: 'آیکن',
  prefetch: 'دانلود خودکار فایل ها',
  noGutters: 'حذف فاصله‌ها',
  serverLimitedCount: 'تعداد قابل نمایش در سرور',
  firstSlideClass: 'کلاس اولین اسلاید',
  lastSlideClass: 'کلاس آخرین اسلاید',
  controlsClass: 'کلاس دکمه‌های قبل/بعد',
  pagination: 'صفحه‌بندی',
  slideClass: 'کلاس اسلاید',
  accordionAttrs: 'آکاردئون',
  accordionIconAttrs: 'آیکن آکاردئون',
  defaultIcon: 'آیکن پیشفرض',
  expandIcon: 'آیکن حالت باز شده',
  expandFirst: 'باز بودن اولین آیتم',
  breakpoints: 'نقاط شکست',
  slidesPerView: 'تعداد قایل نمایش',
  spaceBetween: 'فاصله بین اسلاید ها',
  wrapperAreaAttrs: 'تگ ناحیه',
  areaAttrs: 'ناحیه',
  wrapperPageAttrs: 'تگ صفحه',
  pageAttrs: 'صفحه',
  inputAttrs: 'ورودی',
  validation: 'قوانین اعتبارسنجی',
  inputType: 'نوع ورودی',
  required: 'اجباری',
  showImagePreview: 'نمایش گالری تصویر هنگام کلیک',
  imagePreviewImages: 'آدرس های تصاویر گالری'
}
